const Contact = () => {
  const steps = [
    {
      icon: "/assests/download.png",
      title: "Step 1: Download the App",
      description:
        "Available on iOS and Android, the Home Healthcare App is free to download.",
    },
    {
      icon: "/assests/login.png",
      title: "Step 2: Sign Up or Log In",
      description:
        "Patients, nurses, and physiotherapists can create profiles to get started.",
    },
    {
      icon: "/assests/book.png",
      title: "Step 3: Book or Accept Appointments",
      description:
        "Patients can book appointments with certified professionals, while nurses and physiotherapists can accept appointments based on their availability.",
    },
    {
      icon: "/assests/care.png",
      title: "Step 4: Get Quality Care",
      description:
        "Receive quality care directly at home, whether it’s for routine nursing or physiotherapy sessions.",
    },
  ];

  return (
    <div className="w-full bg-[#fff]">
      <div
        className="w-full h-[20vh] sm:h-[50vh] md:h-[36vh] lg:h-[36vh] xl:h-[36vh] fhd:h-[33vh] bg-fixed bg-cover bg-center flex justify-center items-start"
        style={{
          backgroundImage: `url('${
            window.innerWidth >= 1024
              ? "/assests/plusBG.png"
              : "/assests/plusBG.png"
          }')`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <img
          src="/assests/work.png"
          className="w-[150px] sm:w-[250px] h-[150px] sm:h-[200px] fhd:w-[300px] fhd:h-[250px] flex justify-center items-center mt-10 sm:mt-16 fhd:mt-24"
          alt=""
        />
      </div>
      <section className="py-8 sm:py-12 fhd:py-16 bg-[#fff]">
        <div className="max-w-4xl fhd:max-w-6xl mx-auto text-center">
          <h2 className="text-[28px] sm:text-[32px] md:text-[36px] fhd:text-[42px] font-semibold mb-6 sm:mb-8 fhd:mb-12 font-prata">
            How It Works?
          </h2>
          <div className="space-y-4 sm:space-y-2 fhd:space-y-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className="flex flex-row sm:flex-row items-center lg:items-start p-4 fhd:p-6 hover:bg-gray-50 rounded-lg transition-colors duration-300"
              >
                <img
                  src={step.icon}
                  alt="icon"
                  className="h-[40px] sm:h-[50px] w-[40px] sm:w-[50px] fhd:h-[60px] fhd:w-[60px]"
                />
                <div className="ml-3 sm:ml-4 fhd:ml-6 text-left mt-4 sm:mt-0">
                  <p className="text-[16px] sm:text-lg fhd:text-2xl font-semibold text-gray-800 font-poppins">
                    {step.title}
                  </p>
                  <p className="text-[12px] sm:text-[14px] fhd:text-lg text-gray-600 font-poppins">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
